module.exports = __webpack_public_path__ + "img/coaching.e534745e.svg";